import { environment } from '@env/environment';

export class BaseApiService {
  public queryBaseUrl = `${environment.apiBaseUrl}/query/api`;
  public commandBaseUrl = `${environment.apiBaseUrl}/command/api`;

  protected microserviceApiUrl(name: string) {
    return name ? `${environment.apiBaseUrl}/${name}/api` : `${environment.apiBaseUrl}/api`;
  }
}
